import { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from "react-router-dom";
import './Searchbar.css';
import PropTypes from 'prop-types';

const Searchbar = ({ isAdminView, isDarkMode, toggleAdminView, toggleTheme, notifications, handleProfileClick }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showSettingsPanel, setShowSettingsPanel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [error, setError] = useState(null);
  const [visibleTooltip, setVisibleTooltip] = useState(null);
  const [showDarkModeSettings, setShowDarkModeSettings] = useState(false);
  
  const dropdownVisibleRef = useRef(null);
  const settingsPanelRef = useRef(null);
  const notificationRef = useRef(null); // Ref for notification dropdown

  const navigate = useNavigate();

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const [userSettings, setUserSettings] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    customerId: '',
  });
  if (loading && !error) {
    ""
  }

  useEffect(() => {
    fetchUserSettings();
    //console.log("fffffffffffffff",notifications);

    const handleClickOutside = (event) => {
      if (dropdownVisibleRef.current && !dropdownVisibleRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
      if (settingsPanelRef.current && !settingsPanelRef.current.contains(event.target)) {
        setShowSettingsPanel(false);
      }
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false); // Close notifications on outside click
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownVisible, showSettingsPanel, showNotifications]);

  const fetchUserSettings = useCallback(async () => {
    setLoading(true);
    setError(null);
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }

    const token = getCookie('token');
    const username = getCookie('username');

    try {
      const response = await fetch(`https://infia.enviseer.com/api/api/user/fetchUser?email=${username}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`, // Add the Authorization header with token
          'Accept': 'application/json',
          'X-Application-Name': 'envi-onboarding'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          handleLogout();
        }
        else {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }
      const data = await response.json();
      //console.log("llllllllllll", data);
      setUserSettings({
        username: data.displayName,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        customerId: data.customerId,
      });
    } catch (error) {
      console.error("Error fetching user settings:", error);
      setError(error.message);

    } finally {
      setLoading(false);
    }
  }, [userSettings]);

  const openSettingsPanel = () => {
    toggleDropdown();
    setShowSettingsPanel(true);
  };

const handleLogout = () => {
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  window.location.href = 'https://infia.enviseer.com/';
};

  //getTimeDifference function
  const getTimeDifference = (timestamp) => {
    const now = new Date();
    const timeDiff = Math.abs(now - new Date(timestamp)); // Difference in milliseconds
    const diffMinutes = Math.floor(timeDiff / (1000 * 60));
    const diffHours = Math.floor(timeDiff / (1000 * 60 * 60));
    const diffDays = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  
    if (diffMinutes < 60) {
      return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
    } else if (diffHours < 24) {
      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    } else {
      return `${diffDays} day${diffDays !== 1 ? 's' : ''} ago`;
    }
  };

  const handleClickEnviApps = () =>{
    window.location.href = 'https://infia.enviseer.com/';
  }

  const handleSettingsClick = () => {
    setShowDarkModeSettings(!showDarkModeSettings);
  };
  
  const handleNotificationClick = () => {
    navigate("/notifications");
  };

  return (
    <div className="search-profile-bar">
      <div className="header-icons">

        <div className="icon-wrapper d-none d-md-block"
          onMouseEnter={() => setVisibleTooltip('darkMode')}
          onMouseLeave={() => setVisibleTooltip(null)}>
          <i
            className={`bi ${isDarkMode ? 'bi-sun' : 'bi-moon'}`}
            style={{ cursor: 'pointer'}}
            onClick={toggleTheme}
          ></i>
          {visibleTooltip === 'darkMode' && (
            <div className="custom-tooltip">
              {isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            </div>
          )}
        </div>

        <div className="icon-wrapper d-block"  onClick={()=>{
          if (window.innerWidth <= 576) {
            // Screen size is 'd-sm' or smaller
                handleNotificationClick();
             } else {
              setShowNotifications(!showNotifications);
               }}}
          onMouseEnter={() => setVisibleTooltip('notifications')}
          onMouseLeave={() => setVisibleTooltip(null)}>
          <i className="bi bi-bell-fill" style={{}}></i>
          {notifications.length > 0 && <span className="notification-badge">{notifications.length}</span>} 
          {visibleTooltip === 'notifications' && (
            <div className="custom-tooltip">
              Notifications
            </div>
          )}
        </div>
        {showNotifications && (
          <div className="notification-screen" ref={notificationRef}>
            <div className="arrow-up"></div>
            <h4>Notifications</h4>
            <ul>
            {notifications.length > 0 ? (
              notifications.map((notification, index) => (
                <li key={index} className="dropdown-item">
                  <div className="notification-message"dangerouslySetInnerHTML={{ __html: notification.message }}></div>
                  <div className="notification-time">{getTimeDifference(notification.time)}</div>
                </li>
              ))
            ) : (
              <li className="dropdown-item">No new notifications</li>
            )}
          </ul>
          </div>
        )}


        <div className="icon-wrapper d-none d-md-block" onClick={handleClickEnviApps}
          onMouseEnter={() => setVisibleTooltip('applauncher')}
          onMouseLeave={() => setVisibleTooltip(null)}>
          <i className="bi bi-boxes" style={{}}></i>
          {visibleTooltip === 'applauncher' && (
            <div className="custom-tooltip">
              EnviApps
            </div>
          )}
        </div>

        <div
          className="icon-wrapper d-none d-md-block"
          onMouseEnter={() => setVisibleTooltip('adminView')}
          onMouseLeave={() => setVisibleTooltip(null)}
          data-tooltip={isAdminView ? "Admin View" : "User View"}
          onClick={toggleAdminView}
        >
          {isAdminView ? (
            <i className="bi-briefcase-fill" style={{ cursor: 'pointer' }}></i>
          ) : (
            <i className="bi bi-person-fill" style={{ cursor: 'pointer' }}></i>
          )}
          {visibleTooltip === 'adminView' && (
            <div className="custom-tooltip">
              {isAdminView ? "Switch to user view" : "Switch to admin view"}
            </div>  
          )}
        </div>

        <div className="icon-wrapper">
        <div
              className="profile-circle"
              onClick={() => {
                 if (window.innerWidth <= 576) {
                  // Screen size is 'd-sm' or smaller
                      handleProfileClick();
                   } else {
                      toggleDropdown();
                     }
                 }}
         >
            {userSettings.firstName[0]}{userSettings.lastName[0]}
          </div>
        </div>

        {dropdownVisible && (
          <div className="profile-dropdown" ref={dropdownVisibleRef}>
            <div className="dropdown-header">
              👋 Hey, {userSettings.username}
            </div>
            <div className="dropdown-item" onClick={openSettingsPanel}>Profile</div>
            <div className="dropdown-item" onClick={handleSettingsClick}>Settings</div>
              {showDarkModeSettings && (
                <div className="dropdown-submenu">
                  <div className="dropdown-item">
                    Dark Mode
                    <button onClick={toggleTheme} className="dark-mode-toggle">
                    {isDarkMode ? 'Turn Off' : 'Turn On'}
                    </button>
                  </div>
                </div>
              )}
            <div className="dropdown-item d-block d-md-none" onClick={() => setShowNotifications(!showNotifications)}>
               notification
            {notifications.length > 0 && <span className="notification-badge">{notifications.length}</span>} 
        </div>
            <div className="dropdown-item logout" onClick={handleLogout}>Log out</div>
          </div>
        )}

        {showSettingsPanel && (
          <div className="settings-panel" ref={settingsPanelRef}>
            <div className="settings-panel-header">
              <h5 className="settings-header">Account Settings</h5>
              <i className="bi bi-x-circle" onClick={() => setShowSettingsPanel(false)}></i>
            </div>
            <form className="settings-form">
              <div className="form-group">
                <p> Username : {userSettings.username}</p>
              </div>
              <div className="form-group">
                <p> Email : {userSettings.email}</p>
              </div>
              <div className="form-group">
                <p> Firstname : {userSettings.firstName} </p>
              </div>
              <div className="form-group">
                <p>Lastname : {userSettings.lastName} </p>
              </div>
              <div className="form-group">
                <p>CustomerId : {userSettings.customerId}</p>
              </div>
            </form>
          </div>
        )}
      </div>

    </div>
  );
};

Searchbar.propTypes = {
  isAdminView: PropTypes.bool.isRequired,
  isDarkMode: PropTypes.bool.isRequired,
  toggleAdminView: PropTypes.func.isRequired,
  toggleTheme: PropTypes.func.isRequired,
  handleProfileClick: PropTypes.func.isRequired,
  notifications: PropTypes.string.isRequired,
};

export default Searchbar;
